import { Auth } from 'aws-amplify'

const defaultRegion = 'eu-west-1'

const environments: { [T: string]: any } = {
    local: {
        address: 'http://localhost:3000',
        api: {
            region: defaultRegion,
            endpoint: 'https://czy9w4unel.execute-api.eu-west-1.amazonaws.com'//'http://localhost:3000/dev1'
        },
        auth: {
            userPoolId: 'eu-west-1_AIeMXMyzz',
            identityPoolId: 'eu-west-1:e36c6869-883c-4734-8cec-11fa0550f669',
            userPoolWebClientId: '2thep3odphcuna50ch7152k65r',
            region: defaultRegion
        }
    },
    development: {
        address: 'https://development.d2qvgw8mvqn9ck.amplifyapp.com',
        api: {
            region: defaultRegion,
            endpoint: 'https://czy9w4unel.execute-api.eu-west-1.amazonaws.com'
        },
        auth: {
            userPoolId: 'eu-west-1_AIeMXMyzz',
            userPoolWebClientId: '2thep3odphcuna50ch7152k65r',
            identityPoolId: 'eu-west-1:e36c6869-883c-4734-8cec-11fa0550f669',
            region: defaultRegion
        }
    },
    production: {
        address: 'https://www.quizedu.dk',
        api: {
            region: defaultRegion,
            endpoint: 'https://w1et7853s6.execute-api.eu-west-1.amazonaws.com'
        },
        auth: {
            userPoolId: 'eu-west-1_ByDOnh6A8',
            userPoolWebClientId: '520lcd0gvnf97lsmmo9a8f9n71',
            identityPoolId: 'eu-west-1:d4893e31-62b4-4d53-9f5f-1b3b6201dbeb',
            region: defaultRegion
        }
    }
}

const environment = environments[process.env.NODE_ENV || 'local']

if (!environment) {
    throw Error(`Invalid or unsupported environment: ${process.env.NODE_ENV}`)
}



// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Auth: {
        mandatorySignIn: true,
        ...environment.auth
    },
    Storage: {
        AWSS3: {
            bucket: 'quizcards-docs-dev', //REQUIRED -  Amazon S3 bucket name
            region: 'eu-west-1'
        }
    },
    API: {
        address: environment.address,
        endpoints: [{
            name: 'api',
            region: defaultRegion,
            custom_header: async () => {
                const session = await Auth.currentSession()
                if (session) {
                    return {
                        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
                    }
                } else {
                    return {}
                }
            },
            ...environment.api,

        }, {
            name: 'open-api',
            region: defaultRegion,
            ...environment.api,
        }]
    }
}
